import { ReportType } from '@modules/reports/Domain/reports.model';

export const ReportDescriptions: Record<ReportType, string> = {
  [ReportType.CLIENTS]: 'DATA.MODULES.REPORTS.DESCRIPTION.CLIENTS',
  [ReportType.PANEL]: 'DATA.MODULES.REPORTS.DESCRIPTION.PANEL',
  [ReportType.PANEL_V2]: 'DATA.MODULES.REPORTS.DESCRIPTION.PANEL',
  [ReportType.CAMPAIGNS]: 'DATA.MODULES.REPORTS.DESCRIPTION.CAMPAIGNS',
  [ReportType.COLLECTION]: 'DATA.MODULES.REPORTS.DESCRIPTION.COLLECTION',
  [ReportType.PORTFOLIOS]: 'DATA.MODULES.REPORTS.DESCRIPTION.PORTFOLIOS',
  [ReportType.COLLECTORS]: 'DATA.MODULES.REPORTS.DESCRIPTION.COLLECTORS',
  [ReportType.NOTIFICATIONS]: 'DATA.MODULES.REPORTS.DESCRIPTION.NOTIFICATIONS',
  [ReportType.OUTBOUND_CALLS]: 'DATA.MODULES.REPORTS.DESCRIPTION.OUTBOUND_CALLS',
  [ReportType.COLLECTION_BY_PERIOD]: 'DATA.MODULES.REPORTS.DESCRIPTION.COLLECTION_BY_PERIOD',
  [ReportType.CAMPAIGNS_BY_MONTH]: 'DATA.MODULES.REPORTS.DESCRIPTION.CAMPAIGNS_BY_MONTH',
  [ReportType.DUE_DATE_PERIOD]: 'DATA.MODULES.REPORTS.DESCRIPTION.DUE_DATE_PERIOD',
  [ReportType.DEBT_AGING]: 'DATA.MODULES.REPORTS.DESCRIPTION.DEBT_AGING',
};
